import { render, staticRenderFns } from "./ModifyItem.vue?vue&type=template&id=775a7cd8"
import script from "./ModifyItem.vue?vue&type=script&lang=js"
export * from "./ModifyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports